/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { AnalyticsEventType } from './analyticsEventType'
import type { Cuid } from './cuid'

/**
 * アナリティクスイベントの入力型
 */
export interface TrackEventInput {
  /** 埋め込みページURL */
  embedPageUrl?: string
  /** 動画セッションID */
  videoSessionId?: string
  /** GA4 client_id（embed元サイトから取得） */
  ga4ClientId?: string
  /** デバイスタイプ */
  deviceType?: string
  /** UserAgent */
  userAgent?: string
  /** IPアドレス */
  ipAddress?: string
  /** イベントデータ（JSON）
任意のキー・バリューを含むことができる */
  eventData?: unknown
  /** イベントタイプ */
  eventType: AnalyticsEventType
  /** ノードキー */
  nodeKey?: string
  /** セッションID */
  sessionId: string
  /** シナリオID */
  scenarioId: Cuid
}
